import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PinkGradientButton from '../../UIControls/PinkGradientButton';
import { cetraMobileLogo } from '../../../config';
import { ReactComponent as LogoCircle } from '../../../assets/icons/LogoCircle.svg';

const OnboardResubscribeScreen = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        backgroundColor: '#F0F0FC',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 0, sm: 3 },
        py: { xs: 6, sm: 8 },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '64px',
          height: '64px',
          mb: { xs: '13px', md: '24px' },
        }}
      >
        <Box component={LogoCircle} sx={{ width: '100%', height: '100%', display: 'block' }} />
        <Box
          component="img"
          src={cetraMobileLogo}
          alt="Cetra"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '47.401px',
            height: '36px',
            objectFit: 'contain',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </Box>
      <Box
        component="section"
        sx={{
          width: '100%',
          maxWidth: { xs: 352, md: 646 },
          backgroundColor: '#fff',
          border: '1px solid rgba(102, 102, 102, 0.15)',
          borderRadius: { xs: '16.371px', md: '30px' },
          boxSizing: 'border-box',
          overflow: 'hidden',
          px: { xs: '30.558px', md: '56px' },
          py: { xs: '21.827px', md: '40px' },
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: { xs: '26px', md: '36px' },
            fontWeight: 600,
            lineHeight: { xs: '26px', md: '36px' },
            letterSpacing: { xs: '-0.52px', md: '-0.72px' },
            color: '#000453',
            mb: { xs: '18px', md: '38px' },
            whiteSpace: 'nowrap',
          }}
        >
          Resubscribe today
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: { xs: '14px', md: '22px' },
            fontWeight: 400,
            lineHeight: { xs: '20px', md: '32px' },
            letterSpacing: { xs: '-0.28px', md: '-0.44px' },
            color: '#616063',
            mb: { xs: '30px', md: '64px' },
          }}
        >
          Welcome back! Restart your subscription today to unlock and share our exclusive veterinary content. Save time
          in clinic, enhance pet owner engagement and improve pet health with Cetra.
        </Typography>
        <PinkGradientButton
          onClick={() => navigate('/settings/manage-subscription')}
          sx={{
            width: '100%',
            height: { xs: '34.924px', md: '64px' },
            borderRadius: { xs: '17.462px', md: '32px' },
            marginY: 0,
            fontFamily: 'Inter',
            fontSize: { xs: '14px', md: '22px' },
            fontWeight: 500,
            lineHeight: { xs: '14px', md: 'normal' },
            letterSpacing: { xs: '-0.28px', md: '-0.44px' },
          }}
        >
          Restart subscription
        </PinkGradientButton>
      </Box>
    </Box>
  );
};

export default OnboardResubscribeScreen;
